import { Text } from '@fluentui/react-northstar';

// Component
import HyperLink from 'COMPONENTS/HyperLink';

// Constant
import {
  AKOUO_SUPPORT_URL,
  LANGUAGE_PREFIX,
  TEAMS_LANGUAGE_RESOURCE,
} from 'CONSTANTS/teamsConstants';

// Service
import { useTranslation } from 'SERVICES/i18n';

// Utils
import { IAkouoSupport } from 'UTILS/teamsInterface';

// renders Hyperlink to Akouo Support
const AkouoSupport = ({ size, align, className }: IAkouoSupport) => {
  const { t } = useTranslation(TEAMS_LANGUAGE_RESOURCE, LANGUAGE_PREFIX.COMMON);
  return (
    <Text size={size} align={align} className={className}>
      {t('NEED_ASSISTANCE')}
      <HyperLink link={`${AKOUO_SUPPORT_URL}`} />
    </Text>
  );
};

AkouoSupport.defaultProps = {
  size: undefined,
  align: undefined,
  className: undefined,
};

export default AkouoSupport;
